/**
 * עמודת איקוני הכלים ליד השיחה (צף / מצומד למגירה).
 */
export const CHAT_TOOLS_RAIL_FLOAT_MARGIN_PX = 16;
export const CHAT_TOOLS_RAIL_WIDTH_PX = 50;

/** כפתור סגור במסילה המצומדת — באותו קוטר כמו כפתור קצה הפאנל */
export const CHAT_TOOLS_DOCKED_CLOSE_BTN_DIAMETER_PX = 32;

export const CHAT_TOOLS_RAIL_INLINE_RESERVE_PX =
  CHAT_TOOLS_RAIL_FLOAT_MARGIN_PX + CHAT_TOOLS_RAIL_FLOAT_MARGIN_PX + CHAT_TOOLS_RAIL_WIDTH_PX;
